import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Brand2 = ({ data }) => {
  const baseBackgroundImageUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/";
  const baseImageUrl = "https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/";

  const [showPrev, setShowPrev] = useState(true);
  const [showNext, setShowNext] = useState(true);

  const products = data.get_home_component_details.content.map((item) => ({
    id: item.brand_auto_id,
    name: item.brand_name,
    image: `${baseImageUrl}${item.brand_image_app}`,
  }));

  const navigate = useNavigate();

  const handleAllBrands = () => {
    navigate("/brandlist", {
      state: {
        brand_id: products[0].id,
        brand_name: products[0].name,
      },
    });
  };

  return (
    <>
      {/* 🔥 CSS INCLUDED INSIDE FILE */}
      <style>{`
  /* Slide Hover / scale */
  .brand-slide {
    transition: transform 0.3s ease-in-out;
  }
  .brand-slide:hover {
    transform: scale(1.05);
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    .brand-container {
      height: auto !important;
      padding: 10px;
      flex-direction: column !important;
    }

    .brand-left {
      width: 100% !important;
      padding: 10px !important;
      text-align: center !important;   /* 🔥 Center Title + Button */
      align-items: center !important;  /* 🔥 Center items */
    }

    .brand-title {
      font-size: 26px !important;
      margin-bottom: 5px !important;
      text-align: center !important;   /* 🔥 Center Title */
    }

    .brand-subtitle {
      font-size: 14px !important;
      text-align: center !important;
    }

    /* Center button */
    .brand-left button {
      margin: 10px auto 0 auto !important; /* 🔥 Center Button */
      display: flex !important;
    }

    .brand-swiper {
      width: 100% !important;
      padding: 5px !important;
    }

    @media (max-width: 768px) {
  .brand-slide img {
    height: 300px !important;  /* 🔥 Increased height only for mobile */
    object-fit: cover;
  }
}


    /* Arrows hidden for mobile */
    .swiper-button-prev,
    .swiper-button-next {
      display: none !important;
    }
  }

  /* Desktop arrow styling */
  .swiper-button-prev,
  .swiper-button-next {
    color: black !important;
    font-size: 25px !important;
    z-index: 20 !important;
  }
`}</style>


      <div
        className="w-full h-[500px] bg-cover bg-center flex items-center brand-container"
        style={{
          backgroundImage: `url('${baseBackgroundImageUrl}${data.background_image}')`,
        }}
      >
        {/* LEFT SIDE CONTENT */}
        <div className="w-1/4 flex flex-col justify-start items-start text-black p-4 brand-left">

          {/* Brand Title */}
          <h2
            className={`text-5xl font-bold mb-2 brand-title ${data.web_title_font}`}
            style={{ color: data.web_title_color }}
          >
            {data.title}
          </h2>

          {/* Subtitle */}
          {/* <p
            className={`text-lg mb-4 brand-subtitle ${data.web_title_font}`}
            style={{ color: data.web_title_color }}
          >
            Explore the best collection.
          </p> */}

          <button
            className="flex items-center justify-center bg-transparent text-black p-3 rounded-full border-2"
            onClick={handleAllBrands}
          >
            <FaArrowRight />
          </button>
        </div>

        {/* RIGHT SIDE SWIPER */}
        <div className="w-3/4 brand-swiper">
          <Swiper
  modules={[Navigation]}
  spaceBetween={20}
  slidesPerView={2.5}
  breakpoints={{
    0: {
      slidesPerView: 1.5,   // 🔥 Mobile: 1.5 cards
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3.5,   // 🔥 Desktop: unchanged
      spaceBetween: 20,
    },
  }}
  onSlideChange={(swiper) => {
    setShowPrev(!swiper.isBeginning);
    setShowNext(!swiper.isEnd);
  }}
  navigation={{
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  }}
>

            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <Link
                  to="/brandlist"
                  state={{
                    brand_id: product.id,
                    brand_name: product.name,
                  }}
                >
                  <div className="bg-white p-1 rounded-lg brand-slide">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-96 object-cover rounded"
                    />
                  </div>
                </Link>
              </SwiperSlide>
            ))}

            {/* Arrows (Desktop Only) */}
            {showPrev && (
              <div className="swiper-button-prev absolute top-1/2 left-0 -translate-y-1/2 text-3xl p-3 cursor-pointer">
                <FaArrowLeft />
              </div>
            )}
            {showNext && (
              <div className="swiper-button-next absolute top-1/2 right-0 -translate-y-1/2 text-3xl p-3 cursor-pointer">
                <FaArrowRight />
              </div>
            )}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Brand2;
